<style scoped>
.home-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.map-wrapper {
  width: 100%;
  height: 100%;
}
.left-panel {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 280px;
  max-height: calc(100% - 40px);
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15);
  z-index: 10;
  overflow-y: auto;
}
.search-input {
  margin-bottom: 10px;
}
.new-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}
.bottom-chart {
  position: absolute;
  bottom: 20px;
  left: 320px;
  right: 20px;
  height: 220px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15);
  z-index: 10;
}
</style>

<template>
  <div class="home-wrap">
    <div class="map-wrapper">
      <swqyun-map
        style="width: 100%; height: 100%;"
        :scene-url="sceneUrl"
        :session-key="sessionKey"
        :app-id="appId"
        :vectors="mapVectors"
        :extra-scenes="extraScenes"
        scene="spot"
      />
    </div>

    <div class="left-panel">
      <el-input
        class="search-input"
        v-model="treeKeyword"
        placeholder="搜索图斑"
        prefix-icon="el-icon-search"
        @input="filterTree"
      ></el-input>
      <el-tree
        ref="spotTree"
        :data="treeData"
        :props="{ children: 'children', label: 'label' }"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
        default-expand-all
      ></el-tree>
    </div>

    <div class="new-btn">
      <el-button type="primary" icon="el-icon-plus" @click="openNewTask">新建监测任务</el-button>
    </div>

    <div class="bottom-chart">
      <div ref="chartRef" style="width: 100%; height: 100%;"></div>
    </div>

    <add-spot-task :visible.sync="taskDialogVisible" @success="onTaskCreated" />
  </div>
</template>

<script>
import addSpotTask from "./components/addSpotTask.vue";
import SwqyunMap from "@/components/SwqyunMap.vue";

export default {
  components: { addSpotTask, SwqyunMap },
  data() {
    return {
      treeKeyword: "",
      treeData: [],
      taskDialogVisible: false,
      chartInstance: null,
      chartData: [],
      sceneUrl: "",
      sessionKey: "",
      appId: "",
      mapVectors: [],
      extraScenes: []
    };
  },
  mounted() {
    this.loadMapConfig();
    this.loadTree();
    this.loadStatistics();
    this.loadMapVectors();
    this.loadSpotStageMaps();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    loadMapConfig() {
      const districtId = this.$store.state.districtInfo && this.$store.state.districtInfo.districtId;
      this.$apis.get("/admin/districtMapConfig/detail", { districtId }).then(res => {
        if (res && res.data && res.data.code == 200 && res.data.data) {
          const cfg = res.data.data;
          this.sceneUrl = cfg.sceneUrl;
          this.sessionKey = cfg.sessionKey;
          this.appId = cfg.appId;
        } else {
          // 如果未配置，使用默认测试凭证（与 MineResultMap 中汝城县恒源雷氏矿业毛家铁矿保持一致）
          this.sceneUrl = "https://api.swqyun.com/api/fileManage/Scene/SDKGetScene?id=138b92545134d878d5d90ca45490263c";
          this.sessionKey = "0271ae43f09e427cb6927d6255446bc0b3cec903f45b48a49fb22dba752f52cb";
          this.appId = "31f37381eb434c2b";
        }
      }).catch(() => {
        this.sceneUrl = "https://api.swqyun.com/api/fileManage/Scene/SDKGetScene?id=138b92545134d878d5d90ca45490263c";
        this.sessionKey = "0271ae43f09e427cb6927d6255446bc0b3cec903f45b48a49fb22dba752f52cb";
        this.appId = "31f37381eb434c2b";
      });
    },
    loadTree() {
      this.$apis.get("/admin/dashboard/spotTree").then(res => {
        if (res && res.data && res.data.code == 200) {
          this.treeData = res.data.data || [];
        }
      });
    },
    filterTree() {
      this.$refs.spotTree.filter(this.treeKeyword);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label && data.label.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      if (data.type === "spot" && data.taskId) {
        this.$router.push({ path: "/spotDetail", query: { spotId: data.value } });
      }
    },
    openNewTask() {
      this.taskDialogVisible = true;
    },
    onTaskCreated() {
      this.loadTree();
      this.loadStatistics();
      this.loadMapVectors();
      this.loadSpotStageMaps();
    },
    loadSpotStageMaps() {
      this.$apis.get("/admin/dashboard/spotStageMaps").then(res => {
        if (res && res.data && res.data.code == 200) {
          const list = res.data.data || [];
          this.extraScenes = list.map(item => item.sceneUrl).filter(Boolean);
        }
      });
    },
    loadMapVectors() {
      // 简化：从后端获取当前区县下已监测图斑的矢量数据
      this.$apis.get("/admin/spot/vector/list", { spotId: 0 }).then(res => {
        // 实际项目中需要批量加载
        this.mapVectors = [];
      });
    },
    loadStatistics() {
      this.$apis.get("/admin/dashboard/statistics").then(res => {
        if (res && res.data && res.data.code == 200) {
          this.chartData = res.data.data || [];
          this.renderChart();
        }
      });
    },
    renderChart() {
      if (!this.$refs.chartRef) return;
      if (!this.chartInstance) {
        this.chartInstance = window.echarts.init(this.$refs.chartRef);
      }
      const years = this.chartData.map(item => item.year);
      const option = {
        tooltip: { trigger: "axis" },
        legend: {
          data: ["植被覆盖率(%)", "植被成活率(%)", "土壤质量达标率(%)", "水量质量达标率(%)", "危岩体数(个)"],
          bottom: 0,
          textStyle: { fontSize: 11 }
        },
        grid: { left: "3%", right: "4%", bottom: "15%", top: "10%", containLabel: true },
        xAxis: { type: "category", data: years },
        yAxis: { type: "value" },
        series: [
          { name: "植被覆盖率(%)", type: "bar", data: this.chartData.map(i => i.vegetationCoverage) },
          { name: "植被成活率(%)", type: "bar", data: this.chartData.map(i => i.vegetationSurvivalRate) },
          { name: "土壤质量达标率(%)", type: "bar", data: this.chartData.map(i => i.soilQualityRate) },
          { name: "水量质量达标率(%)", type: "bar", data: this.chartData.map(i => i.waterQualityRate) },
          { name: "危岩体数(个)", type: "bar", data: this.chartData.map(i => i.dangerRockCount) }
        ]
      };
      this.chartInstance.setOption(option, true);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/home.vue